import { SvgIcon, SvgIconMap } from "@ponder-shared/utils/svgIcons";

/**
 * Navigates to an arbitrary URL (internal or external).
 */
export class SidebarButtonLinkComponent {
    public readonly svgIcon!: string;

    public constructor(
        public readonly label: string, 
        public readonly icon: SvgIcon, 
        public readonly url: string, 
        public readonly disabled: boolean) {
        this.svgIcon = SvgIconMap.get(icon)!;
    }
}